<template>
    <div>
        <form autocomplete="off">
            <div>
                <a-checkbox
                    class="mb-4"
                    id="acceptTermsOfUse"
                    v-model="form.acceptTermsOfUse"
                >{{ $t("iAccept") }}
                </a-checkbox>
                <a href="https://assets.website-files.com/61c1fc0c4b29a848ee7d2928/633149af2ffcde097e5b8fba_20220815_Terms%20of%20Use.pdf"
                   target="_blank"
                   class="text-primary-500">{{ $t("terms") }}</a>
                <div v-if="validation.fieldErrors['acceptTermsOfUse']" class="text-red-500 text-xs italic">
                    {{ validation.fieldErrors['acceptTermsOfUse'] }}
                </div>
            </div>
            <div>
                <a-checkbox
                    class="mb-4"
                    id="acceptPrivacyPolicy"
                    v-model="form.acceptPrivacyPolicy"
                >{{ $t("iAccept") }}
                </a-checkbox>
                <a href="https://www.kilde.sg/privacy"
                   target="_blank"
                   class="text-primary-500">{{ $t("privacyPolicy") }}</a>
                <div v-if="validation.fieldErrors['acceptPrivacyPolicy']" class="text-red-500 text-xs italic">
                    {{ validation.fieldErrors['acceptPrivacyPolicy'] }}
                </div>
            </div>
            <div class="mt-6">
                <k-button @click.native.prevent="onSubmit">
                    {{ $t("submit") }}
                </k-button>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    props: {
        validation: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            landingUrl: process.env.VUE_APP_KILDE_LENDING_BASE_URL,
            form: {
                acceptTermsOfUse: null,
                acceptPrivacyPolicy: null
            }
        }
    },
    methods: {
        async onSubmit() {
            this.$emit('submit', this.form);
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
    }
}
</script>
